import Icon from '../../components/Icon.vue'

Icon.register({"brands/bluetooth-b":{"width":320,"height":512,"paths":[{"d":"M196.5 260L289.1 156.7 143.1 0V206.3L57 120.2 25.6 151.6 133.7 260 25.6 368.4 57 399.8 143.1 313.7 145.8 512 294.4 363.4 196.5 260zM237.3 157L187.4 207 187 106.7 237.3 157zM187.4 313L237.3 363 187 413.3 187.4 313z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/brands/bluetooth-b.js
// module id = null
// module chunks = 